module.exports = __webpack_public_path__ + "static/london-marathon-7ad0306c015c56a592e7be6547cf4abc.jpg";